module.exports = __webpack_public_path__ + "static/media/298409.9a92a4c4.png";